import { z } from 'zod'
import { fr } from 'zod/v4/locales'

z.config(fr())
